module.exports = __webpack_public_path__ + "static/media/lp-1.0ed62943.png";